import { render, staticRenderFns } from "./AdvanceReportButton.vue?vue&type=template&id=b045effc"
import script from "./AdvanceReportButton.vue?vue&type=script&lang=js"
export * from "./AdvanceReportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports